export default "dist/images/components-columns-width-control-4-3-grid.33b2e7c.png";